import React, { Component } from "react";
import { SearchInput } from 'com-gyf-webcore-userinterfacecomponents';
import TableRow from './TableRow.jsx';
import { LogHelper } from 'com-gyf-webcore-loghelper';

const BACK_KEY_CODE = 8;
const ENTER_KEY_CODE = 13;
const DELETE_KEY_CODE = 46;

/**
 * Clase encargada de crear el cuerpo para las filas de solo lectura y edicion
 */
class TableBody extends Component {
    constructor(props) {
        super(props);
        //props.data.tarjetas.forEach((tar) => { if (!tar.Nombre) tar.Nombre = ""; });
        const tarjetas = JSON.parse(JSON.stringify(props.tarjetas));

        this.state = {
            searchName: "",
            tarjetas: tarjetas,
            tarjetasOriginales: tarjetas
        }

        this.handleChange = this.handleChange.bind(this);
    }
    /**
     * 
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        const tarjetas = JSON.parse(JSON.stringify(nextProps.tarjetas));
        this.state.tarjetas = tarjetas;
        this.state.tarjetasOriginales = tarjetas;
    }

    /**
     * Maneja el cambio de estado del input cuando cambia la busqueda del cliente
     * @param {any} event Objeto de tipo event con los atributos del evento generado por la accion de elemento
     */
    handleChange(event) {
        const term = event.target.value;
        let tarjetasNuevas = [];

        if (term.length >= 3) {
            tarjetasNuevas = this.state.tarjetas.filter((tar) => { return (tar.ClienteNombre || "").toLowerCase().indexOf(term) >= 0 });
        } else {
            tarjetasNuevas = this.state.tarjetasOriginales;
        }

        this.setState({
            searchName: term,
            tarjetas: tarjetasNuevas
        });
    }

    render() {
        let me = this;
        let props = this.props.data;
        let permisos = props.functions;
        let cuentaSeleccionada = this.props.cuentaSeleccionada;
        const { ModalidadDistribucionLimiteId } = cuentaSeleccionada;
        const { novedadesTarjetas, mostrarMensajeLimitesIguales } = this.props;
        
        let componenteMostrarMensajeLimitesIguales = null;
        if (props.estadoMostrarMensajeLimitesIguales) {
            componenteMostrarMensajeLimitesIguales = (<div className="row no-margin-right">
                <div className="col-xs-1"></div>
                <div className="col-xs-11">
                    <label className="label-primary">Este valor ya existe, ingrese otro diferente.</label>
                </div>
            </div>);
        }

        let searchInputAttr = {
            maxLength: 40,
            className: "form-control",
            placeholder: "Buscar por nombre...",
            value: this.state.searchName
        };

        let promedio = 0;
        let rows = (<div className="row no-margin-right">
            <div className="col-xs-12">
                <label className="label-primary">No se encontró ninguna tarjeta para la cuenta seleccionada. Por favor, cree una Nueva tarjeta para continuar.</label>
            </div>
        </div>);

        //Valor de la cuenta segun el limite de la tarjeta
        let valorCuenta = 0;
        let cantidadTarjetas = 0;
        let limiteCompraTotal = 0;

        //Si el usuario o la cuenta tienen permisos sobre la confidencialidad
        if ((permisos.Confidencial == true) || (cuentaSeleccionada.EsConfidencial == false)) {
            cantidadTarjetas = this.state.tarjetas.length;

            //Si la modalidad de distribucion de limites es límite único por tarjeta, el total no puede superar el 100%
            if (ModalidadDistribucionLimiteId == 2) {
                this.state.tarjetas.forEach((tar) => {
                    let novedadTarjeta = novedadesTarjetas.find((nt) => nt.TarjetaCreditoId == tar.TarjetaCreditoId);

                    if (novedadTarjeta) {
                        limiteCompraTotal += parseFloat(novedadTarjeta.ValorNovedad);
                    } else {
                        limiteCompraTotal += parseFloat(tar.PorcentajeLimiteCompra);
                    }
                });
            }
            rows = this.state.tarjetas.map((tar, index) => {
                if (ModalidadDistribucionLimiteId > 1) {
                    let limite = tar.PorcentajeLimiteCompra;

                    let novedadTarjeta = novedadesTarjetas.find((nt) => nt.TarjetaCreditoId == tar.TarjetaCreditoId);

                    if (novedadTarjeta) {
                        limite = novedadTarjeta.ValorNovedad;
                    }

                    //if (!isNaN(tar.Limite) && tar.Limite > 0) {
                    //    limite = tar.Limite;
                    //} else if (!isNaN(tar.limite) && tar.limite > 0) {
                    //    limite = tar.limite;
                    //} else {
                    //    limite = tar.limit;
                    //}

                    //if (!(limite == "" || limite == 0 || limite == undefined)) {
                    valorCuenta = ((limite * cuentaSeleccionada.Valor) / 100);
                    //}
                }

                return (
                    <TableRow
                        tarjeta={tar}
                        novedades={me.props.data.novedadesTarjetas}
                        key={"LIMIT_DIST_CREDIT_CARD_" + index}
                        valorCuenta={valorCuenta}
                        seEstaEditando={me.props.data.seEstaEditando}
                        cuentaId={cuentaSeleccionada.Id}
                        modalidadDistribucionLimiteId={ModalidadDistribucionLimiteId}
                        cambiarLimite={me.props.cambiarLimite}
                        mostrarMensajeLimitesIguales={me.props.mostrarMensajeLimitesIguales}
                        cambiarModoEdicion={me.props.cambiarModoEdicion}
                        limiteCompraTotal={limiteCompraTotal} />
                );
            });
        }

        promedio = cantidadTarjetas != 0 ? (100 / cantidadTarjetas).toFixed(2) : 0;

        return (<div className="bottom-separator-xxs">
            <div className="row bottom-separator-xxs">

                {componenteMostrarMensajeLimitesIguales}

                <div className="col-xs-1"></div>
                <div className="col-xs-4" id="searchInputContainer">
                    <SearchInput caller="tableBody"
                        listSource={props.tarjetas}
                        propertyToFind="ClienteNombre"
                        onChangeHandle={this.handleChange}
                        {...searchInputAttr} />
                </div>
                <div className="col-xs-7">
                    {/*ModalidadDistribucionLimiteId == 3
                        ? <a className="btn-link" onClick={() =>
                            this.props.cambiarLimite(undefined, promedio, true)}>Distribuir de manera uniforme: {promedio}% por tarjeta</a>
                        : null*/}
                </div>
            </div>
            <div className="scroll">
                {rows}
            </div>
        </div>);
    }
}

export default TableBody